var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVillagePond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2676_681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0118 21.3408C43.0118 27.747 41.416 32.0554 35.1481 37.8125C35.0308 37.922 21.838 49.1477 21.838 49.1477C21.838 49.1477 8.58982 37.7317 8.47247 37.6222C3.67948 33.4076 0.671875 27.747 0.671875 21.3408C0.671875 9.64715 10.152 0.174805 21.838 0.174805C33.5317 0.174805 43.0118 9.64715 43.0118 21.3408Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9186 38.7147C31.6012 38.7147 39.4505 30.8654 39.4505 21.1828C39.4505 11.5002 31.6012 3.65088 21.9186 3.65088C12.236 3.65088 4.38672 11.5002 4.38672 21.1828C4.38672 30.8654 12.236 38.7147 21.9186 38.7147Z",
    fill: "#FFB510",
    stroke: "#FFAA00",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.582 14.8037C13.582 14.8037 20.6459 17.2931 30.5182 14.8037",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.582 20.5742C13.582 20.5742 20.6459 23.0636 30.5182 20.5742",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.582 26.3447C13.582 26.3447 20.6459 28.8341 30.5182 26.3447",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2676_681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.671875 0.174805)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVillagePond);
export default __webpack_public_path__ + "static/media/village-pond.21390aaed49da53ad4298dd69d0bcc41.svg";
export { ForwardRef as ReactComponent };